"use client";

import { useParams, usePathname } from "next/navigation";
import { useEffect } from "react";

import { SITE_NAME } from "@shared/constants";

export default function PageClasses() {
  const params = useParams<{ journey: string }>();
  const pathname = usePathname();

  useEffect(() => {
    const classes: string[] = [];
    const pathSegments = pathname.split("/");

    // Generate 'Journey' class (if applicable)
    if (pathSegments.length > 1) {
      if (params.journey) {
        classes.push(`page_journey_${params.journey}`);
      } else {
        classes.push(`page_journey_${pathSegments[1]}`);
      }
    }

    // Generate 'Name' class
    if (pathname === "/") {
      SITE_NAME === "Veteran Debt Assistance"
        ? classes.push("page_name_home--financial-education")
        : classes.push("page_name_home");
    } else if (pathname === "/about") {
      SITE_NAME === "Veteran Debt Assistance"
        ? classes.push("page_name_about--financial-education")
        : classes.push("page_name_about");
    } else {
      let pageName = pathname.slice(1).replaceAll("/", "-");

      if (params.journey) {
        pageName = pageName.replace(new RegExp(`${params.journey}-?`), "");

        if (pageName === "") {
          pageName = "landing-page";
        }
      }

      classes.push(`page_name_${pageName}`);
    }

    // Generate 'Flow' class
    if (pathname.includes("offers")) {
      classes.push("page_flow_secondary-offers");
    }

    // Add 'page' classes
    document.getElementById("page")?.classList.add(...classes);

    // Remove 'page' classes
    return () => {
      document.getElementById("page")?.classList.remove(...classes);
    };
  }, [params, pathname]);

  return null;
}
